import { IMenuItemsButtonStyle, IMenuStyleData } from "@pageBuilder/typings";
import { BaseItemsStylesRenderer } from "./base-items-styles-renderer";
import { CssProperties } from "../../../../models/css-property";

export class ButtonItemsStylesRenderer extends BaseItemsStylesRenderer {

    public override render(element: HTMLElement, style: IMenuStyleData): void {
        super.renderFontStyle(element, style);

        const buttonStyle = style.itemsLayoutTypeStyle as IMenuItemsButtonStyle;
        if (!buttonStyle) {
            return;
        }

        if (buttonStyle.radius) {
            const buttonLayoutCss = new CssProperties();
            buttonLayoutCss.tryAdd("border-top-left-radius", `${buttonStyle.radius.topLeftPx}px`);
            buttonLayoutCss.tryAdd("border-bottom-left-radius", `${buttonStyle.radius.bottomLeftPx}px`);
            buttonLayoutCss.tryAdd("border-top-right-radius", `${buttonStyle.radius.topRightPx}px`);
            buttonLayoutCss.tryAdd("border-bottom-right-radius", `${buttonStyle.radius.bottomRightPx}px`);
            this.styleService.setStyle(element, this.getButtonStyleSelector(element.id), buttonLayoutCss.data);
        }

        this.renderButtonDefaultColors(element, style, buttonStyle);
        this.renderButtonHoveredColors(element, style, buttonStyle);
        this.renderButtonActiveColors(element, style, buttonStyle);
    }

    private renderButtonDefaultColors(element: HTMLElement, style: IMenuStyleData, buttonStyle: IMenuItemsButtonStyle | null): void {
        const buttonCss = new CssProperties();
        if (buttonStyle?.colors?.colorHovered) {
            buttonCss.tryAdd("background-color", `${buttonStyle?.colors.colorDefault}`);
        }

        if (style.linkColorStyleData?.colorDefault) {
            buttonCss.tryAdd("color", `${style.linkColorStyleData?.colorDefault}`);
        }

        if (buttonCss.data.length) {
            this.styleService.setStyle(element, this.getButtonStyleSelectorNotHovered(element.id), buttonCss.data);
        }
    }

    private renderButtonHoveredColors(element: HTMLElement, style: IMenuStyleData, buttonStyle: IMenuItemsButtonStyle | null): void {
        const buttonCss = new CssProperties();
        if (buttonStyle?.colors?.colorHovered) {
            buttonCss.tryAdd("background-color", `${buttonStyle?.colors.colorHovered}`);
        }

        if (style.linkColorStyleData?.colorHovered) {
            buttonCss.tryAdd("color", `${style.linkColorStyleData?.colorHovered}`);
        }

        if (buttonCss.data.length) {
            this.styleService.setStyle(element, this.getButtonStyleSelectorHover(element.id), buttonCss.data);
        }
    }

    private renderButtonActiveColors(element: HTMLElement, style: IMenuStyleData, buttonStyle: IMenuItemsButtonStyle | null): void {
        const buttonCss = new CssProperties();
        if (buttonStyle?.colors?.colorClicked) {
            buttonCss.tryAdd("background-color", `${buttonStyle?.colors.colorClicked}`);
        }

        if (style.linkColorStyleData?.colorClicked) {
            buttonCss.tryAdd("color", `${style.linkColorStyleData?.colorClicked}`);
        }

        if (buttonCss.data.length) {
            this.styleService.setStyle(element, this.getButtonStyleSelectorActive(element.id), buttonCss.data);
        }
    }

    private getButtonStyleSelector(id: string): string {
        return `#${id} ul.root.button > li > .nav-item-name`;
    }

    private getButtonStyleSelectorNotHovered(id: string): string {
        return `#${id} ul.root.button > li > .nav-item-name:not(:hover)`;
    }

    private getButtonStyleSelectorHover(id: string): string {
        return `#${id} ul.root.button > li > .nav-item-name:hover`;
    }

    private getButtonStyleSelectorActive(id: string): string {
        return `#${id} ul.root.button > li.active > .nav-item-name:not(:hover)`;
    }

    public getStyleSpecificSelectors(id: string): Array<string> {
        return [
            this.getButtonStyleSelector(id),
            this.getButtonStyleSelectorNotHovered(id),
            this.getButtonStyleSelectorHover(id),
            this.getButtonStyleSelectorActive(id)
        ];
    }

}
